import { cn } from '@/common/utilities.ts'
import { ChildrenProp } from '@/common/types_and_interfaces.ts' // Assuming cn function is in utils file

const SemanticColors = {
  Positive: 'text-green-700 bg-green-50 ring-green-600/20',
  Notice: 'text-yellow-600 bg-yellow-50 ring-yellow-600/20',
  Negative: 'text-red-700 bg-red-50 ring-red-600/20',
  Informative: 'text-blue-700 bg-blue-50 ring-blue-600/20',
  Transparent: 'text-gray-700 bg-white-50 ring-gray-600/20',
  Neutral: 'bg-gray-50 ring-gray-600/20',
} as const

export type ColorType = keyof typeof SemanticColors

type StatusBadgeProps = {
  semanticColor: ColorType
  className?: string
} & ChildrenProp

export default function Badge({
  semanticColor,
  className = '',
  children,
}: StatusBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset',
        SemanticColors[semanticColor],
        className
      )}
    >
      {children}
    </span>
  )
}
